module.exports = __webpack_public_path__ + "sprintly.100960.svg";